import React from 'react'
import Slider from "react-slick"
import tech from  './techs.module.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaArrowAltCircleLeft, FaArrowAltCircleRight, FaRegArrowAltCircleLeft, FaRegArrowAltCircleRight } from 'react-icons/fa';
const Tech = () => {
    const sliderRef = React.useRef(null);

    // const CustomPrevArrow = (props) => {
    //     const { onClick } = props;
    //     return <div className={tech.customPrev} onClick={onClick} >
    //         {/* <FaArrowAltCircleLeft onClick={onClick} /> */}
    //     </div>
    //   };
      
    //   const CustomNextArrow = (props) => {
    //     const { onClick } = props;
    //     return <div className={tech.customNext} onClick={onClick} >
    //                 {/* <FaArrowAltCircleRight  onClick={onClick} /> */}
    //            </div>
    //     ;
    //   };

    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false,
        draggable: true, // Enable dragging with mouse
        swipe: true, // Enable touch swipe for mobile
        touchMove: true, // Ensure touch movement is smooth
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              initialSlide: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      };



  return (
    <div className={tech.tech} >
      <div className={tech.container}>
        <div className={tech.content}>
            <div className={tech.vidI}>
            <iframe src="https://www.youtube.com/embed/rUf-egn9aYI?si=0spmHdNbOqeuGDRs" 
             title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div className={tech.block}>
                <div className={tech.head}>
                    <button className={tech.btn}>Trending live</button>
                </div>
                <Slider ref={sliderRef} {...settings} className={tech.flex}  >
                    
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        
                   
                </Slider>
                    <div className={tech.arrowsContainer}>
                         <button  onClick={() => sliderRef.current.slickPrev()}>
                         <FaRegArrowAltCircleLeft className={tech.customPrev} />
                           
                        </button>
                         <button  onClick={() => sliderRef.current.slickNext()}>
                                <FaRegArrowAltCircleRight className={tech.customNext}/>
                              
                         </button>
                    
                    </div>
            </div>
            <div className={tech.block}>
                <div className={tech.head}>
                    <button className={tech.btni}>Trending live</button>
                </div>
                <Slider ref={sliderRef} {...settings} className={tech.flex}  >
                    
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        
                   
                </Slider>
                    <div className={tech.arrowsContainer}>
                         <button  onClick={() => sliderRef.current.slickPrev()}>
                         <FaRegArrowAltCircleLeft className={tech.customPrev} />
                           
                        </button>
                         <button  onClick={() => sliderRef.current.slickNext()}>
                                <FaRegArrowAltCircleRight className={tech.customNext}/>
                              
                         </button>
                    
                    </div>
            </div>
            <div className={tech.block}>
                <div className={tech.head}>
                    <button className={tech.btnii}>New Uploaded</button>
                </div>
                <Slider ref={sliderRef} {...settings} className={tech.flex}  >
                    
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        
                   
                </Slider>
                    <div className={tech.arrowsContainer}>
                         <button  onClick={() => sliderRef.current.slickPrev()}>
                         <FaRegArrowAltCircleLeft className={tech.customPrev} />
                           
                        </button>
                         <button  onClick={() => sliderRef.current.slickNext()}>
                                <FaRegArrowAltCircleRight className={tech.customNext}/>
                              
                         </button>
                    
                    </div>
            </div>
            <div className={tech.block}>
                <div className={tech.head}>
                    <button className={tech.btniii}>Most Viewed</button>
                </div>
                <Slider ref={sliderRef} {...settings} className={tech.flex}  >
                    
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className={tech.card}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/F28utmcAciQ?si=a8e3o5SLdoxJxjPj" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        
                   
                </Slider>
                    <div className={tech.arrowsContainer}>
                         <button  onClick={() => sliderRef.current.slickPrev()}>
                         <FaRegArrowAltCircleLeft className={tech.customPrev} />
                           
                        </button>
                         <button  onClick={() => sliderRef.current.slickNext()}>
                                <FaRegArrowAltCircleRight className={tech.customNext}/>
                              
                         </button>
                    
                    </div>
            </div>
            <div className={tech.blocki}>
                <h2>Ads Post</h2>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Tech
